import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCautionSvg } from "./IconCautionSvg.mjs";
const IconCaution = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconCautionSvg, ...svgProps }) });
export {
  IconCaution
};
